import { useAppSelector } from 'redux-store';

export default function useSplitYearlyCost(): {
  isNeedToSplitYearPrice: boolean;
} {
  const productsStore = useAppSelector(state => {
    return state.products;
  });
  let isNeedToSplitYearPrice = false;

  if (productsStore.isFetched) {
    const { products } = productsStore;

    if (
      products.length === 2 &&
      products[0].prices[0].interval === 'month' &&
      products[1].prices[0].interval === 'year'
    ) {
      isNeedToSplitYearPrice = true;
    }
  }

  return { isNeedToSplitYearPrice };
}
